import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces, hexToRgbaWithAlpha } from '../../theme';
import { mask } from '../../styles/mixins';

const HEADER_HEIGHT = 30;

export const useListEditDrawerStyles = createStyles(({ token }) => ({
  listEditDrawer: {
    '&.ant-drawer-open .ant-drawer-content-wrapper': {
      boxShadow: `-4px 0 30px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH, 0.9)}`,
    },

    '.ant-drawer-content-wrapper': {
      height: 'auto',
      top: ThemeSpaces.SPACE_NORM,
      bottom: ThemeSpaces.SPACE_NORM,
      borderTopLeftRadius: 9,
      borderBottomLeftRadius: 9,

      [`@media (min-width: ${token.screenLGMin}px)`]: {
        width: '964px !important',
        maxWidth: '96vw',
      },
      [`@media (max-width: ${token.screenMDMax}px)`]: {
        width: '96vw !important',
      },
    },

    '.ant-drawer-content': {
      borderTopLeftRadius: 9,
      borderBottomLeftRadius: 9,
      ...mask(85),
      backdropFilter: 'blur(3px)',
    },

    '.ant-drawer-mask': {
      backgroundColor: 'transparent',
    },

    '.ant-drawer-header-title': {
      height: HEADER_HEIGHT,
      borderRadius: 0,
      borderTopLeftRadius: 9,
      backgroundColor: ThemeColors.COLOR_GREY_BLUISH,
      padding: `0 ${ThemeSpaces.SPACE_MD}px`,
      borderWidth: 0,
      display: 'flex',
      flexDirection: 'row-reverse',
      alignItems: 'center',
      justifyContent: 'space-between',
    },

    '&& .ant-drawer-close': {
      position: 'relative',
      marginRight: 0,
      padding: 0,
    },

    '.ant-drawer-title': {
      color: ThemeColors.COLOR_WHITE,
      fontFamily: 'Roboto Condensed, sans-serif',
      fontWeight: 'bold',
      fontSize: token.fontSizeLG,
    },

    '.IconButton': {
      color: ThemeColors.COLOR_WHITE,
      fontSize: token.fontSizeHeading4,
    },

    '.ant-drawer-body': {
      padding: 0,
    },
  },
}));
